var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item,attrs:{"label":_vm.$t(item.toLowerCase()),"value":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }